// extracted by mini-css-extract-plugin
export default {"tabs":"d_h","tab-list":"d_j","tab":"d_k","active":"d_l"};